var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyFilledEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.625C8.25 13.056 8.07879 13.4693 7.77405 13.774C7.4693 14.0788 7.05598 14.25 6.625 14.25C6.19402 14.25 5.7807 14.0788 5.47595 13.774C5.17121 13.4693 5 13.056 5 12.625C5 12.194 5.17121 11.7807 5.47595 11.476C5.7807 11.1712 6.19402 11 6.625 11C7.05598 11 7.4693 11.1712 7.77405 11.476C8.07879 11.7807 8.25 12.194 8.25 12.625Z",
    fill: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0278 12.625C14.0278 12.8384 13.9858 13.0497 13.9041 13.2469C13.8225 13.444 13.7028 13.6232 13.5519 13.774C13.401 13.9249 13.2218 14.0446 13.0247 14.1263C12.8275 14.208 12.6162 14.25 12.4028 14.25C12.1894 14.25 11.9781 14.208 11.781 14.1263C11.5838 14.0446 11.4047 13.9249 11.2538 13.774C11.1029 13.6232 10.9832 13.444 10.9015 13.2469C10.8199 13.0497 10.7778 12.8384 10.7778 12.625C10.7778 12.194 10.949 11.7807 11.2538 11.476C11.5585 11.1712 11.9719 11 12.4028 11C12.8338 11 13.2471 11.1712 13.5519 11.476C13.8566 11.7807 14.0278 12.194 14.0278 12.625Z",
    fill: "#3CB4E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1805 14.25C18.3939 14.25 18.6052 14.208 18.8024 14.1263C18.9996 14.0446 19.1787 13.9249 19.3296 13.774C19.4805 13.6232 19.6002 13.444 19.6818 13.2469C19.7635 13.0497 19.8055 12.8384 19.8055 12.625C19.8055 12.4116 19.7635 12.2003 19.6818 12.0031C19.6002 11.806 19.4805 11.6268 19.3296 11.476C19.1787 11.3251 18.9996 11.2054 18.8024 11.1237C18.6052 11.042 18.3939 11 18.1805 11C17.7496 11 17.3362 11.1712 17.0315 11.476C16.7267 11.7807 16.5555 12.194 16.5555 12.625C16.5555 13.056 16.7267 13.4693 17.0315 13.774C17.3362 14.0788 17.7496 14.25 18.1805 14.25Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyFilledEllipsis);
export default __webpack_public_path__ + "static/media/greyFilledEllipsis.ececa80db0236c75075995e00aeab920.svg";
export { ForwardRef as ReactComponent };